<div class="left">
    <i class="icon fa {{leftIcon}}" [class.highlighted]="highlighted"></i>
</div>
<div class="center">
    <div class="title">{{ title }}</div>
    <div class="subtitle"><span [innerHTML]="subtitle"></span></div>
    <div class="description"><span [innerHTML]="description"></span></div>
</div>
<div class="right">
    <app-icon *ngIf="hasDelete"
              class="delete"
              type="danger"
              simple="true"
              library="fontawesome"
              variant="fa-trash"
              (click)="onDeleteIconClick($event)">
    </app-icon>
    <app-icon *ngIf="rightIcon"
              class="action"
              type="info"
              simple="true"
              library="fontawesome"
              variant="{{rightIcon}}"
              (click)="onRightIconClick($event)">
    </app-icon>
</div>

